import { createTheme } from '@mui/material';
import { defaultTheme } from 'react-admin';
import { muiComponentsTheme, raComponentsTheme } from './componentsTheme';
import { palette } from './palette';
import { shape } from './shape';
import { typography } from './typography';

//@ts-ignore - Fix TS FS-3199
const baseTheme = createTheme(defaultTheme, {
    palette,
    shape,
    typography,
    components: muiComponentsTheme,
    sidebar: { width: 280, closedWidth: 88 },
});

// React admin doesn't handle callbacks inside the style overrides so we create it separately
export const finalTheme = createTheme(baseTheme, {
    components: raComponentsTheme(baseTheme),
});
